import React from "react";
import { CheckCircle2Icon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { images } from "../../data/content";
const trust = ["One-time payment of $27", "Instant digital access", "Lifetime access to purchased files", "7-day money-back guarantee, subject to the published refund policy"];
export function HeroSection() {
  return <>
      <div className="bg-cta px-4 py-2.5 text-center" data-id="element-245" data-mp="1s9oa0xgherha">
        <p className="font-display text-[13px] font-extrabold uppercase leading-tight tracking-wide text-white md:text-sm" data-id="element-246" data-mp="1sb91ge7i1uax">
          Exclusive launch offer · 6 volumes + 5 bonuses for only $27
        </p>
      </div>
      <section className="bg-navy px-4 pb-16 pt-10 text-white md:pb-24 md:pt-16" data-id="element-247" data-mp="1ihs9zguu4raf">
        <div className="mx-auto grid max-w-6xl items-center gap-8 lg:grid-cols-[1.05fr_1fr] lg:gap-12" data-id="element-248" data-mp="1dmctsi9cujau">
          <div className="text-center lg:text-left" data-id="element-249" data-mp="19idhkbv3y6na">
            <p className="font-display text-lg font-black uppercase tracking-wide text-gold md:text-xl" data-id="element-250" data-mp="14jk7ktf14xrv">
              Shoulder Assessment Blueprint™
            </p>
            <h1 className="mt-3 text-balance font-display text-[32px] font-black uppercase leading-[1.05] md:text-6xl" data-id="element-251" data-mp="31mb4xre1dpo9">
              Assess shoulder pain with a <span className="text-cta" data-id="element-252" data-mp="2sohaklzu163q">clearer clinical framework</span>
            </h1>
            <img src={images.mockup} alt="Shoulder Assessment Blueprint: 6 volumes and 5 bonuses shown on books, laptop, tablet and phone" className="mx-auto mt-8 w-full max-w-lg lg:hidden" data-id="element-253" data-mp="2wo9q5inn8cil" />
            <p className="mt-6 text-lg leading-relaxed text-white/85 md:text-xl" data-id="element-254" data-mp="3pbm97iuli275">
              A practical, step-by-step educational system designed to help physiotherapists organize their shoulder
              assessments, review relevant examination procedures, interpret clinical findings, and develop more
              structured clinical reasoning.
            </p>
            <p className="mt-6 inline-block rounded-xl bg-white/10 px-4 py-3 font-display text-base font-extrabold uppercase leading-snug text-white md:text-lg" data-id="element-255" data-mp="24yn2siude7qc">
              6 comprehensive volumes + 5 specialized clinical resources
            </p>
            <p className="mt-5 text-base text-brand-soft" data-id="element-256" data-mp="rll2qqygh3i">
              Developed by <strong className="text-white" data-id="element-257" data-mp="pqx13ke08v7">Dr. Ryan Carter</strong> for physiotherapists and physical
              therapy students who want a clearer approach to evaluating shoulder pain.
            </p>
            <div className="mt-8" data-id="element-258" data-mp="3nu6tnmc66g4j">
              <CtaButton id="hero-cta" label="Get the complete blueprint" data-id="element-259" data-mp="3iwx4m7sp06h8" />
            </div>
            <ul className="mx-auto mt-6 grid max-w-xl gap-2 text-left sm:grid-cols-2 lg:mx-0" data-id="element-260" data-mp="3dxu0cpkje4ab">
              {trust.map(t => <li key={t} className="flex items-start gap-2 text-sm text-white/85" data-id="element-261" data-mp="39y3dgwy4s8b2">
                  <CheckCircle2Icon className="mt-0.5 h-4 w-4 shrink-0 text-good" aria-hidden="true" data-id="element-262" data-mp="1c5z3vh6uq6co" />
                  {t}
                </li>)}
            </ul>
          </div>
          <img src={images.mockup} alt="Shoulder Assessment Blueprint: 6 volumes and 5 bonuses" className="hidden w-full lg:block" data-id="element-263" data-mp="2q3torabw8q6p" />
        </div>
      </section>
    </>;
}